import { CREATE_TICKET, GET_ALL_USERS } from "./Constants";

export const getAllUsersRequest = () => ({
  type: GET_ALL_USERS.GET_ALL_USERS_LOAD,
});

export const setAllUsersSuccess = (data) => ({
  type: GET_ALL_USERS.GET_ALL_USERS_SUCCESS,
  data,
});

export const setAllUsersFail = (error) => ({
  type: GET_ALL_USERS.GET_ALL_USERS_FAIL,
  error,
});


export const createTicketRequest = (payload) => ({
  type: CREATE_TICKET.CREATE_TICKET_LOAD,
  payload,
});

export const createTicketSuccess = (data) => ({
  type: CREATE_TICKET.CREATE_TICKET_SUCCESS,
  data,
});

export const createTicketFail = (error) => ({
  type: CREATE_TICKET.CREATE_TICKET_FAIL,
  error,
})

export const resetCreateTicket = () => ({
  type: CREATE_TICKET.CREATE_TICKET_RESET,
});